import React from 'react';

import { TL2Category$L4Group } from 'Components/CategoryGroups/CategoryGroups.helpers';
import CategoryGroups from 'Components/CategoryGroups/CategoryGroups';
import ScrolltoFloatButton from 'Components/ScrolltoFloatButton/ScrolltoFloatButton';

import CategoryList from './ContactlessCategoryList.json';

type CategoryGroups$Props = {
  l4Groups: TL2Category$L4Group[];
  l2Id?: string;
  city?: string;
  sectionHeader?: React.ReactNode;
};

const ContactlessCategories: React.FC<CategoryGroups$Props> = ({ l4Groups, l2Id, city, sectionHeader }) => {
  return (
    <div>
      <ScrolltoFloatButton />
      {sectionHeader}
      <CategoryGroups linkToAllServices categories={CategoryList} city={city} l2Id={l2Id} />
    </div>
  );
};

export default ContactlessCategories;
